import { format } from 'date-fns';
export const dateFormat = (initialDate) => {
    const date = new Date(initialDate);
    const options = {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    };
    return date.toLocaleDateString('en-US', options);
};
export const dateFormatForUser = (initialDate) => {
    const date = new Date(initialDate);
    const options = {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    };
    return date.toLocaleDateString('en-US', options);
};
export const parseDate = (date) => {
    try {
        return format(date, 'dd MMMM yyyy HH:mm a zzz');
    }
    catch (error) {
        return `${date}`;
    }
};
export const parseDateStr = (date, formatStr) => {
    try {
        return format(date, formatStr);
    }
    catch (error) {
        return `${date}`;
    }
};
export const parseDateFromStr = (date) => {
    try {
        return format(new Date(date), 'dd MMMM yyyy HH:mm a zzz');
    }
    catch (error) {
        return `${date}`;
    }
};
export const formatDateLocal = (dateString) => {
    try {
        const dateObject = new Date(dateString);
        return dateObject.toLocaleString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hour12: true
        });
    }
    catch (error) {
        return `${dateString}`;
    }
};
export const formatDateUTC = (dateString) => {
    try {
        const dateObject = new Date(dateString);
        return dateObject.toUTCString().replace('GMT', 'UTC');
    }
    catch (error) {
        return `${dateString}`;
    }
};
